export default __webpack_public_path__ + "static/media/LeAndrena-Hadlock.421c244a.jpg";